import { Box, Stack, styled } from '@mui/material'
import React from 'react'
import { _ContentTitleWithMarginTop } from './styles'
import { ColorConf } from '@/config/color';

const DescriptionWrapper = styled(Box)({
  position: "relative",
  backgroundColor: ColorConf.White,
  width: "100%",
  padding: "10px 16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});
const DescriptionIndexLabel = styled(Box)({
  position: "absolute",
  top: 16,
  left: 30,
  color: ColorConf.HeroPrimaryColor,
  fontSize: 13,
  fontWeight: 500,
  textAlign: "center",
  transform: "rotate(-10deg)",
});
const Description = styled(Box)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 17,
  fontWeight: 700,
  color: ColorConf.HeroPrimaryText,
  lineHeight: "24px",
  textAlign: "center",
  padding: 20,
  width: "94%",
});
const DescriptionTextGrey = styled(Box)({
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 13,
  lineHeight: "20px",
  color: ColorConf.HeroSecondaryText,
  letterSpacing: "0.1em",
  textAlign: "center",
  padding: 15,
  marginBottom: 25,
});

const Points = () => {
  return (
    <div>
      <_ContentTitleWithMarginTop>
        <img src="/images/uraharu-logo.svg" alt="logo" style={{ width: 87, height: 21 }} />
        の特徴
      </_ContentTitleWithMarginTop>
      <Stack
        sx={{
          flexDirection: "row",
          "@media (max-width: 600px)": {
            flexDirection: "column",
          }
        }}
      >
        <DescriptionWrapper>
          <DescriptionIndexLabel>Point 01</DescriptionIndexLabel>
          <Description>気になったら「いいね」を送信するだけ！</Description>
          <img src="/images/hero-line4.png" alt="hero-line.avif" style={{ width: 229, height: 25, marginTop: -20 }} />
          <img
            src={"/images/570.png"}
            alt=""
            style={{
              width: 160,
              objectFit: "cover"
            }}
          />
          <DescriptionTextGrey style={{ marginTop: -30 }}>
          いいねを送信すると男性に通知が届き、<span style={{ color: ColorConf.HeroPrimaryColor, fontWeight: 900 }}>自動でマッチ。</span> また、いいねの送信にはメッセージの送信やテンプレのコピペなどは一切必要ありません。
          </DescriptionTextGrey>
        </DescriptionWrapper>
        <DescriptionWrapper>
          <DescriptionIndexLabel>Point 02</DescriptionIndexLabel>
          <Description>
            マッチするまで女性のプロフィールは 見られません！
          </Description>
          <img src="/images/hero-line4.png" alt="hero-line.avif" style={{ width: 229, height: 25, marginTop: -20 }} />
          <img
            src={"/images/601.png"}
            alt=""
            style={{
              width: 160,
              objectFit: "cover"
            }}
          />
          <DescriptionTextGrey style={{ marginTop: -30 }}>
            女性がいいねして初めて男性は女性を確認することができるので、<span style={{ color: ColorConf.HeroPrimaryColor, fontWeight: 900 }}>プライバシーも安全</span>です。身バレの危険性もありません。
          </DescriptionTextGrey>
        </DescriptionWrapper>
      </Stack>
    </div>
  )
}

export default Points